export enum GlobalStateType {
    POSITION_BIT = 0x00,
    DYNAMICS_BIT = 0x01,
    PRESSURE_BIT = 0x02,
    SATELLITE_BIT = 0x03,
    GSM_BIT = 0x04,
    LATENCY_BIT = 0x05,
    SW_BIT = 0x06,
    ML_BIT = 0x07,
    GSMS_BIT = 0x08
}

export namespace GlobalStateType {
    export function getState(state: number, index: GlobalStateType) {
        return (state & (1 << index)) != 0;
    }
}